// const path = 'http://192.168.10.197:9092';
const VERSION_URL = '/getReleaseVersions';
export { VERSION_URL }